'use client'

/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { usePathname } from 'next/navigation'
import assetLoader from '@utils/internalImageLoader'
import { getFullFormattedDate } from '@components/Ackodrive/common/utils'
import Image from 'next/image'
import { ITEM_ID, ITEM_TYPE, TEAM_ACKODRIVE } from '@components/Ackodrive/common/constants'
import { cleanPathname } from '@components/Ackodrive/common/urlValidation'
import styles from './styles/recentItems.module.scss'

const RecentItems = ({ recentItems, itemType = ITEM_TYPE.NEWS, itemId = ITEM_ID.NEWS }: any) => {
  const pathname = usePathname()

  return (
    <div className={styles.RecentItemWrapper} id="recentItems">
      <div className={styles.RecentItemHeader}>
        <span className={styles.ItemHeaderText}>Recent</span>
        <span className={styles.ItemHeaderText}>{itemType}</span>
      </div>
      <div className={styles.RecentItemList}>
        {recentItems?.map((item: any) => {
          const oneItem = item?.attributes
          const authorName = oneItem?.authorName?.data?.attributes?.name || TEAM_ACKODRIVE

          return (
            <div className={styles.RecentItem} key={item?.data?.id}>
              <a href={itemId === 'articles' ? cleanPathname(oneItem?.url) : cleanPathname(`/${itemId}/${oneItem?.slug}/`)}>
                <p className={styles.RecentItemTitle}>{oneItem?.title || oneItem?.articleTitle}</p>
              </a>
              <p className={styles.RecentItemInfo}>
                {authorName} <span className={styles.Circle} /> {getFullFormattedDate(oneItem?.createdAt)}
              </p>
            </div>
          )
        })}
      </div>
      {pathname !== `/${itemId}` ? (
        <a href={`/${itemId}/`} key="all-items">
          <div className={styles.AllItemsLink}>
            <span>All {itemType}</span>
            <Image src={`${assetLoader()}/images/arrow-right.svg`} alt="icon" width="20" height="20" />
          </div>
        </a>
      ) : null}
    </div>
  )
}

export default RecentItems
